import { AnyObject } from './GenericInterfaces'
import { Country, Language } from './Global'
import { ProductType } from './Product'

export const ProductSyncActions = ['create', 'delete', 'update'] as const
export type ProductSyncAction = (typeof ProductSyncActions)[number]
export type MarketSyncAction = 'publish' | 'unpublish'
export const WCStockStatuses = ['instock', 'outofstock'] as const
export type WCStockStatus = (typeof WCStockStatuses)[number]
export const WCProductStatuses = ['publish', 'draft', 'pending', 'private'] as const
export type WCProductStatus = (typeof WCProductStatuses)[number]

export const ShopifyProductStatuses = ['ACTIVE', 'DRAFT', 'ARCHIVED'] as const
export type ShopifyProductStatus = (typeof ShopifyProductStatuses)[number]

export interface SyncPreview {
  [siteId: string]: {
    [marketHandle: string]: {
      total: number
      included: string[]
      excluded: { marketRequirements: string[]; status: string[]; excludedObjects: string[]; invalidProductType: string[] }
      excludedCount: number
    }
  }
}

export type ECommerceFramework = 'wc' | 'shopify'

export interface Site {
  id: string
  markets: Market[]
  framework: 'wc' | 'shopify'
}

export interface Market {
  name: string
  handle: string
  language: Language
  country: Country
  order?: number
  autoSync: boolean
  isRetailerStore: boolean
}

export const SelloSiteId = 'Sello WC' // TODO "magic string"

export const ignorableRules = ['sellable web from', 'availability status', 'exclude from ecommerce-sync', 'available in countries'] as const
export type IgnorableRule = (typeof ignorableRules)[number]

export interface ECommerceSyncPayload {
  marketHandlesBySiteId: { [siteId: string]: string[] | undefined }
  includedCountries: Country[]
  productsQuery: AnyObject
  includeProductsMissingAvailableCountries: boolean
  productSyncAction: ProductSyncAction
  shopifyMarketSyncAction: MarketSyncAction
  wcProductStatus: WCProductStatus | undefined
  shopifyProductStatus: ShopifyProductStatus | undefined
  wcStockStatus: WCStockStatus | undefined
  ignoredRules: IgnorableRule[]
  productType?: ProductType
}
